import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('g', { id: 'Artboard-32' }),
  React.createElement('polygon', { points: '26.25 6.94 26.25 2.73 24.95 2.73 24.95 6.94 20.75 6.94 20.75 8.24 24.95 8.24 24.95 12.44 26.25 12.44 26.25 8.24 30.46 8.24 30.46 6.94 26.25 6.94' }),
  React.createElement('path', { d: 'M15,7.75a4.73,4.73,0,1,0,4.73,4.73A4.73,4.73,0,0,0,15,7.75Zm0,8.16a3.43,3.43,0,1,1,3.43-3.43A3.44,3.44,0,0,1,15,15.91Z' }),
  React.createElement('path', { d: 'M27.53,14.58A13.52,13.52,0,0,1,27.61,16a12.39,12.39,0,0,1-4.49,9.54v-.4a6.57,6.57,0,0,0-6.56-6.55h-3A6.56,6.56,0,0,0,7,25.14v.06A12.38,12.38,0,0,1,19.73,4.46l.48-1.21a13.7,13.7,0,1,0,8.61,11.19ZM8.27,26.23V25.14a5.26,5.26,0,0,1,5.25-5.25h3a5.26,5.26,0,0,1,5.25,5.25v1.33a12.32,12.32,0,0,1-13.54-.24Z' })
));